module.exports = __webpack_public_path__ + "img/ecopayz.902655b9.svg";